import { Link } from 'react-router-dom';
import { Stack } from '@chakra-ui/react';
import { Typography } from '@shinetools/sunshine-universal';

import SunshineCard from 'components/_core/SunshineCard';
import SquircleIcon from 'components/_core/SunshineSquircleIcon';
import * as Layout from 'layouts/ContentLayout';

import * as routes from '../../routes';
import { RecurringExportsList } from './components/RecurringExportsList';
import locales from './locales';

export const NewExportsHome = () => {
  return (
    <Layout.Root>
      <Layout.Body>
        <Stack gap="space-32">
          <Stack>
            <Typography.Header size="large">{locales.title}</Typography.Header>

            <Typography.Text size="large" variant="secondary">
              {locales.description}
            </Typography.Text>
          </Stack>

          <Stack>
            <Typography.Text size="small" variant="discreet">
              {locales.newExport}
            </Typography.Text>

            <SunshineCard.Group>
              <SunshineCard
                alignItems="center"
                as={Link}
                title={locales.generateExport}
                to={routes.newExport}
              >
                <SunshineCard.Slot name="aside">
                  <SquircleIcon name="receipt" />
                </SunshineCard.Slot>

                <SunshineCard.Slot name="action">
                  <SunshineCard.SunshineIcon name="chevron-right" />
                </SunshineCard.Slot>
              </SunshineCard>

              <SunshineCard
                alignItems="center"
                as={Link}
                title={locales.accessBankStatements}
                to={routes.documents}
              >
                <SunshineCard.Slot name="aside">
                  <SquircleIcon name="wallet" />
                </SunshineCard.Slot>

                <SunshineCard.Slot name="action">
                  <SunshineCard.SunshineIcon name="chevron-right" />
                </SunshineCard.Slot>
              </SunshineCard>
            </SunshineCard.Group>
          </Stack>

          <RecurringExportsList />
        </Stack>
      </Layout.Body>
    </Layout.Root>
  );
};
